export var isModifierPressed = function (event, modifiers) {
  if (Array.isArray(modifiers)) {
    return modifiers.every(function (key) {
      return event[key];
    });
  }
  return event[modifiers];
};